module.exports = __webpack_public_path__ + "static/media/food-carton-dieline.8339cfe9.svg";